import { render, staticRenderFns } from "./ChannelReports.vue?vue&type=template&id=0c9fe290&"
import script from "./ChannelReports.vue?vue&type=script&lang=js&"
export * from "./ChannelReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports